<template>
  <img :src="imageFailed ? defaultLogoURL : logoURL" alt="金电保" :width="width" :height="height" decoding="async" @error="imageFailed = true" />
</template>

<script>
import { defaultSiteLogoURL, resolveSiteLogoURL } from '@/utils/site-logo';

export default {
  name: 'BrandLogo',
  props: {
    width: { type: [Number, String], default: 40 },
    height: { type: [Number, String], default: 40 },
  },
  data() {
    return { imageFailed: false, defaultLogoURL: defaultSiteLogoURL };
  },
  computed: {
    logoURL() {
      const config = this.$store.getters.getConfig;
      return resolveSiteLogoURL(config.logo_src, config.public_file_base_url);
    },
  },
  watch: {
    logoURL() { this.imageFailed = false; },
  },
};
</script>

<style scoped>
img { display: block; flex-shrink: 0; object-fit: contain; }
</style>
